var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.clickRateTableList,
            "header-cell-style": {
              color: "#000000",
              fontFamily: "Satoshi-Medium !important",
              fontSize: "14px"
            },
            stripe: "",
            border: ""
          }
        },
        [
          _c("el-table-column", {
            attrs: { width: "350", label: "Contact" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", { staticClass: "contact" }, [
                      _vm._v(_vm._s(scope.row.contact))
                    ])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { width: "350", label: "Store Name" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.storeName
                      ? _c(
                          "span",
                          {
                            staticClass: "store-name",
                            on: {
                              click: function($event) {
                                return _vm.openReport(scope.row)
                              }
                            }
                          },
                          [_vm._v(_vm._s(scope.row.storeName))]
                        )
                      : _c("span", { staticClass: "store-name-na" }, [
                          _vm._v("N/A")
                        ])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "Opens" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.opens
                      ? _c("span", { staticClass: "opens" }, [
                          _vm._v(_vm._s(scope.row.opens))
                        ])
                      : _c("span", { staticClass: "opens" }, [_vm._v("0")])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "Clicks" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.clicks
                      ? _c("span", { staticClass: "clicks" }, [
                          _vm._v(_vm._s(scope.row.clicks))
                        ])
                      : _c("span", { staticClass: "clicks" }, [_vm._v("0")])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("Pagination", {
        attrs: {
          currentPage: _vm.query.pageNo,
          total: _vm.total,
          pageSize: _vm.query.pageSize
        },
        on: {
          handleSizeChange: _vm.handleSizeChange,
          handleCurrentChange: _vm.handleCurrentChange
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6696d2d3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6696d2d3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/store-based-marketing/store-based-marketing-detail/click-rate.vue
// module id = qh9b
// module chunks = 2